import {BUYER_DRAFT, NEGOTIATION_RESPONDED, RESPONDED} from 'rfp/bid-manager/main/core/actions/action/status';

const ALLOWED_ACCOUNTS = [
  // '599ba82a4ddb390a5e34beaa' // Test Corp
  // TODO: Add Amazon eventually
];

export function shouldAllowBuyerDraftNegotiations(bidReport){
  if(bidReport.user !== 'BUYER') return false;
  return isAllowedAccount(bidReport);
}

export function getAllowedStatesForNegotiationRequestUpload(bidsReport) {
  return isAllowedAccount(bidsReport)? [NEGOTIATION_RESPONDED, RESPONDED, BUYER_DRAFT]: [NEGOTIATION_RESPONDED, RESPONDED];
}

function isAllowedAccount(report){
  return !ALLOWED_ACCOUNTS.length || ALLOWED_ACCOUNTS.includes(report.view.ownerId);
}
